/* import __COLOCATED_TEMPLATE__ from './numeric-scale.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();